<table role="grid" aria-labelledby="gridLabel" class="table" id="search-results">
  <thead>
  <tr>
    <th tabindex="-1" *ngFor="let headerName of headerNames">{{headerName}}</th>
  </tr>
  </thead>
  <tbody>
    <ng-container *ngIf="searchResults && searchResults.length > 0; else showEmptyState">
      <tr *ngFor="let row of searchResults; let index=index" [routerLink]="'product/' + row.smartNumber" [attr.id]="'search-result-row-'+ index">
        <ng-container *ngIf="row.componentId">
          <td data-class="search-result-row_componentName">{{row.componentName}}</td>
          <td data-class="search-result-row_componentVersion">{{row.componentVersion}}</td>
        </ng-container>
        <td data-class="search-result-row_publishingStatus">
          <span [ngClass]="badgeClasses[row.publishingStatus]" class="badge cmxa-status-badge">
            {{row.publishingStatus}}
          </span>
        </td>
        <td data-class="search-result-row_productStatus">
          <span [ngClass]="badgeClasses[row.productStatus]" class="badge cmxa-status-wide-badge">
            {{row.productStatus}}
          </span>
        </td>
        <td>
          <ng-container *ngIf="row['hasPublishedVersion']; else disabledLink">
            <a [id]="'cmxa-search-isPublished-' + index"
               [href]="ENV.cmxClientUrl + '?smartNumber=' + row.originalProductSmartNumber" target="_blank"
               adapt-button type="tertiary"
               adaptTooltip="View published version"
               class="btn btn-link cmx-view-published-btn">
              <span class="d-icon-arrow_right_eye"></span>
            </a>
          </ng-container>
          <ng-template #disabledLink>
            <button [id]="'cmxa-search-isPublished-' + index"
                    adapt-button
                    btn-type="tertiary"
                    adaptTooltip="No published version available on the CMX Client"
                    class="btn btn-link disabled cmx-view-published-btn">
              <span class="d-icon-arrow_right_eye"></span>
            </button>
          </ng-template>
        </td>
        <td data-class="search-result-row_productType">{{row.productType | titlecase}}</td>
        <td data-class="search-result-row_productSubType">{{row.productSubType | titlecase}}</td>
        <td data-class="search-result-row_version" class="text-active">{{row.version}}</td>
        <td data-class="search-result-row_servicePackName" *ngIf="isServicePack" class="text-active min-width">{{row.servicePackName}}</td>
        <td data-class="search-result-row_name" class="text-active">{{row.name}}</td>
        <td data-class="search-result-row_smartNumber">{{row.smartNumber}}</td>
        <td data-class="search-result-row_supportStatus">{{row.supportStatus}}</td>
        <td data-class="search-result-row_availabityDate">{{row.availabityDate | normalizeDate}}</td>
        <td data-class="search-result-row_fullSuppEndDate">{{row.fullSuppEndDate | normalizeDate}}</td>
        <td data-class="search-result-row_projObsDate">{{row.projObsDate | normalizeDate}}</td>
      </tr>
    </ng-container>
    <ng-template #showEmptyState>
      <tr id="search-empty">
        <td colspan="12">
          <adapt-empty-state [type]="'objects'"
                             [label]="'Products not found'">
          </adapt-empty-state>
        </td>
      </tr>
    </ng-template>
  </tbody>
</table>
<div id="arrow-keys-indicator" class="hidden"></div>
